module.exports = __webpack_public_path__ + "static/media/flora.8ea5b220.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/flora.jpeg
// module id = 279
// module chunks = 0